import { BooleanInput } from '@angular/cdk/coercion';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { PlatformNavigationService } from '@platform/components/navigation/navigation.service';
import { PlatformNavigationItem } from '@platform/components/navigation/navigation.types';
import { PlatformVerticalNavigationBasicItemComponent } from '@platform/components/navigation/vertical/components/basic/basic.component';
import { PlatformVerticalNavigationCollapsableItemComponent } from '@platform/components/navigation/vertical/components/collapsable/collapsable.component';
import { PlatformVerticalNavigationDividerItemComponent } from '@platform/components/navigation/vertical/components/divider/divider.component';
import { PlatformVerticalNavigationSpacerItemComponent } from '@platform/components/navigation/vertical/components/spacer/spacer.component';
import { PlatformVerticalNavigationComponent } from '@platform/components/navigation/vertical/vertical.component';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector       : 'platform-vertical-navigation-group-item',
    templateUrl    : './group.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone     : true,
    imports        : [NgClass, NgIf, MatIconModule, NgFor, PlatformVerticalNavigationBasicItemComponent, PlatformVerticalNavigationCollapsableItemComponent, PlatformVerticalNavigationDividerItemComponent, forwardRef(() => PlatformVerticalNavigationGroupItemComponent), PlatformVerticalNavigationSpacerItemComponent],
})
export class PlatformVerticalNavigationGroupItemComponent implements OnInit, OnDestroy
{
    /* eslint-disable @typescript-eslint/naming-convention */
    static ngAcceptInputType_autoCollapse: BooleanInput;
    /* eslint-enable @typescript-eslint/naming-convention */

    @Input() autoCollapse: boolean;
    @Input() item: PlatformNavigationItem;
    @Input() name: string;

    private _platformVerticalNavigationComponent: PlatformVerticalNavigationComponent;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _platformNavigationService: PlatformNavigationService,
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        // Get the parent navigation component
        this._platformVerticalNavigationComponent = this._platformNavigationService.getComponent(this.name);

        // Subscribe to onRefreshed on the navigation component
        this._platformVerticalNavigationComponent.onRefreshed.pipe(
            takeUntil(this._unsubscribeAll),
        ).subscribe(() =>
        {
            // Mark for check
            this._changeDetectorRef.markForCheck();
        });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any
    {
        return item.id || index;
    }
}
